<div class="matrix-component" id="matrixTop">
    <div class="content" *ngIf="dataToDisplay">
        <div class="top" [attr.data-automation-id]="automationId + '-view-sort-to-bar-options'">
            <div class="results">
                <span>View:</span>
                <button type="button" [attr.data-automation-id]="automationId + '-view-top50-button'"
                    [ngClass]="isTop50 ? 'btn-group-active' : 'btn-group-default'" title="Top 50 By Count" [disabled]="reportGenerationInProgress || cellSelectionReportGenerationInProgress">
                    <div>Top 50</div>
                    <i class="fa fa-caret-up up-caret-active" [hidden]="!isTop50"></i>
                </button>
            </div>
            <div class="sort" [attr.data-automation-id]="automationId + '-sort-options'">
                <span>Sort:</span>
                <div>
                    <button type="button" [ngClass]="sortType === 'COUNT' ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setSortType('COUNT')" [disabled]="reportGenerationInProgress || cellSelectionReportGenerationInProgress"
                        [attr.data-automation-id]="automationId + '-sort-by-count-button'">
                        <div>By Count</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="sortType !== 'COUNT'"></i>
                    </button>
                    <button data-automation-id="freeform-button" type="button"
                        [disabled]="reportGenerationInProgress || cellSelectionReportGenerationInProgress"
                        [ngClass]="sortType === 'NAME' ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setSortType('NAME')" [attr.data-automation-id]="automationId + '-sort-a-z-button'">
                        <div>A - Z</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="sortType !== 'NAME'"></i>
                    </button>
                </div>
            </div>

            <span class="oldest-report-span" *ngIf="!isBusy && !reportInProgress && data.values.length > 0"
                data-automation-id="reports-oldest-report-label">Latest Report:
                <span>{{oldestReportDate}}</span>
            </span>
            <div class="generate-report">
                <button type="button" [attr.data-automation-id]="automationId + '-generate-report-button'"
                    [disabled]="(isBusy || reportGenerationInProgress || data.values.length === 0) && !cellSelectionReportGenerationInProgress"
                    class="secondary-button right" (click)="generateReport()"
                    *ngIf="hasGenerateReportVisiblePermissions">
                    <div class="iconContainer">
                        <span class="fa-stack">
                            <i class="iconFirst fa-stack-1x fa fa-list-alt color-grey-06"></i>
                            <i class="iconSecond fa-stack-1x fa fa-retweet color-blue-01"></i>
                        </span>
                        <span class="btn-label">Generate Report ...</span>
                    </div>
                </button>
            </div>
            <button type="button" class="secondary-button right-align" data-automation-id="reports-update-button"
                [disabled]="isBusy || reportInProgress || reportGenerationInProgress || cellSelectionReportGenerationInProgress" (click)="updateReport()"><i
                    class="fa fa-refresh update-button-icon"></i>Update</button>
            <div class="help left-10">
                <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                    (click)="openHelp()">
                    <i class="fa fa-question"></i>
                </button>
            </div>
        </div>

        <div class="matrix" [resBusySpinner]="isBusy" [message]="isBusyMessage"
            [attr.data-automation-id]="automationId + '-container'">
            <div class="matrix-container" [hidden]="isBusy || reportInProgress">
                <table>
                    <tr>
                        <th [hidden]="!hasData">
                            <div class="to-from">
                                <div class="selected-cells">
                                    <div><span class="selected-cells-text"> Selected:</span> {{selectedCellsCount.toLocaleString()}}</div>
                                    <div class="deselect-all" (click)="deselectAllCells($event)"
                                        [ngClass]="cellsSelected?.length === 0 ? 'disabled-deselect-all' : ''"><a>Deselect All</a></div>
                                </div>
                                <span class="from"> FROM:</span>
                                <span class="to"> TO/CC/BCC:</span>
                            </div>
                        </th>
                        <th *ngFor="let f of data.from; let i = index" #allFromData clickHighlight class="to-address" (click)="toHeaderClick(i)"
                            id="header{{i}}" [attr.data-automation-id]="automationId + '-from-address-grid-cell-' + f + '-name-label'">
                            <div class="address-format-to" title="{{f}}">
                                <div class="row-total-to"
                                    [attr.data-automation-id]="automationId + '-from-address-' + f + '-total'">
                                    {{data.fromTotal[i]}}
                                </div>
                                <div class="add-step" [attr.data-automation-id]="automationId + '-from-address-' + f">
                                    {{f}}
                                </div>
                            </div>
                        </th>
                    </tr>
                    <tr *ngFor="let t of data.to; let i = index" class="from-address"
                        [attr.data-automation-id]="automationId + '-to-address-grid-container'"
                        [ngClass]="[!viewScroll ? 'bottom-border' : '']" id="row{{i}}">
                        <td *ngFor="let c of data.columns; let j = index"
                            [ngClass]="[j === 0 ? 'address-format-from' : 'data-cells']"
                            [attr.data-automation-id]="j === 0 ? automationId + '-to-address-grid-cell-' + t + '-name-label' :
                            automationId + '-to-from-address-' + t  + '-' + data.from[j-1]" id="{{data.from[j-1] + '|' + t}}">
                            <ng-container *ngIf="j === 0">
                                <div class="add-step" clickHighlight (click)="fromHeaderClick(i)" title="{{t}}"
                                    (mouseenter)="fromMouseOver(i)" (mouseleave)="fromMouseOut(i)">
                                    <div class="address-name"
                                        [attr.data-automation-id]="automationId + '-to-address-' + t">{{t}}</div>
                                    <div class="row-total-from"
                                        [attr.data-automation-id]="automationId + '-to-address-' + t + '-total'">
                                        {{data.toTotal[i]}}
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="j !== 0">
                                <div class="address-format-data" [attr.raw-data-value]="data.rawValues[i][j]">
                                    <div class="single-cell" clickHighlight (click)="cellClick(t,i,j)" (mouseenter)="cellMouseOver(t,j)"
                                        (mouseleave)="cellMouseOut(t,j)"
                                        >
                                        {{data.values[i][j]}}
                                    </div>
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <div *ngIf="!dataToDisplay && !reportInProgress && !isBusy" class="no-data-or-disabled-panel no-data-color"
        [attr.data-automation-id]="automationId + '-no-data-report'">
        <span class="no-data">{{"No Data to Display"}}</span>
    </div>
</div>

<res-resizer anchor="up" [ellipsisExpander]="true" resizingElementId="matrixTop"
secondElementId="gridBottom" [usePercentages]="true" [initSize]="60" [minSize]="20" [maxSize]="95">
</res-resizer>

<div class="doc-list-grid" id="gridBottom">
    <div class="content-panel">
            <res-document-list #matrixGrid [loadDataFinishedCallback]="loadDataFinishedCallback"></res-document-list>
    </div>
</div>